import {
  ExtendedFieldMetaProps,
  ShowErrorsOptions
} from '../fields/GenericFieldWithErrors';

export const shouldShowErrors = (
  showErrors: ShowErrorsOptions,
  touched: boolean,
  active: boolean,
  autoFocus?: boolean,
  ignoreTouch?: boolean
) => {
  const isTouched = touched;
  const isIntentTouched = touched && (!autoFocus || !ignoreTouch);

  const shouldShow =
    (showErrors === true ||
      (showErrors === 'touched' && isTouched) ||
      (showErrors === 'intentTouched' && isIntentTouched)) &&
    !active;

  return shouldShow;
};
